import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui-checkbox',
  standalone: true,
  imports: [CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  template: `
    <label class="ui-checkbox" [class.is-disabled]="disabled">
      <input
        class="ui-checkbox__input"
        type="checkbox"
        [id]="id"
        [checked]="value"
        [disabled]="disabled"
        (change)="onNativeChange($event)"
        (blur)="onTouched()"
      />
      <span class="ui-checkbox__label"><ng-content></ng-content></span>
    </label>
  `,
  styles: [
    `
    :host{display:block;}
    .ui-checkbox{display:flex;align-items:center;gap:10px;cursor:pointer;user-select:none;margin:0;}
    .ui-checkbox.is-disabled{cursor:not-allowed;opacity:0.7;}
    .ui-checkbox__input{width:16px;height:16px;margin:0;flex:0 0 auto;}
    .ui-checkbox__label{display:inline-flex;align-items:center;line-height:1.1;}
    `,
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() id: string | null = null;
  @Input() disabled = false;
  @Input() set checked(v: any) { this.writeValue(v); }

  @Output() checkedChange = new EventEmitter<boolean>();

  value = false;

  private onChangeFn: (v: boolean) => void = () => {};
  private onTouchedFn: () => void = () => {};

  writeValue(value: any): void {
    this.value = !!value;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onTouched(): void {
    this.onTouchedFn();
  }

  onNativeChange(evt: Event): void {
    const el = evt.target as HTMLInputElement | null;
    const checked = !!el?.checked;
    this.value = checked;
    this.onChangeFn(checked);
    this.checkedChange.emit(checked);
  }
}
